import { Div, Label } from "@grassrootly/rn-core";
import { GamePreviewProps } from "./GamePreview.types";
import moment from "moment";
import { isFinished } from "./lib";

export default function GamePreviewInfo({ game }: GamePreviewProps) {
  return (
    <Div classNames={["bw-{1}", "borderPrimary", "w-{100%}", "br-{20}", "ph-{10}", "pt-{10}", "pb-{40}"]}>
      {isFinished(game) && game.location ? (
        <Label classNames={["ml-{15}", "mt-{-20}", "bgNeutralDarkerDark", "ph4", "alignSelfFlexStart"]}>
          {game.location}
        </Label>
      ) : null}
      <Label classNames={["ml-{auto}", "mr-{15}", "mt-{-20}", "bgNeutralDarkerDark", "ph4"]}>
        {game.group.name.toUpperCase()}
      </Label>
      <Div classNames={["mt-{15}", "flexRow", "justifyContentCenter"]}>
        {isFinished(game) ? (
          <Label classNames={["mb-{16}"]} type="l3Regular">
            {moment(game.datetime).format("DD.MM.YYYY HH:mm")}
          </Label>
        ) : null}
      </Div>
      <Div classNames={["flexRow", "alignItemsCenter", "justifyContentCenter"]}>
        <Div classNames={["flexRow", "alignItemsCenter", "flex1"]}>
          <Label classNames={["mr-{5}", "h5", "ml-{auto}"]}>Beli</Label>
          {/* LOGO */}
          <Div
            classNames={[
              "p-{2}",
              "bgSecondaryMain",
              "borderPrimary",
              "bw-{1}",
              "h-{30}",
              "w-{30}",
              "br-{30}",
              "alignItemsCenter",
              "justifyContentCenter",
              "mr-{10}",
            ]}
          >
            <Label type="l1Regular">B</Label>
          </Div>
          {game.host_score != null ? (
            <Label classNames={["mr-{15}"]} type="l1Bold">
              {game.host_score}
            </Label>
          ) : null}
        </Div>
        <Div>
          <Label type="l1Bold">-</Label>
        </Div>
        <Div classNames={["flexRow", "alignItemsCenter", "flex1"]}>
          {game.visitor_score != null ? (
            <Label classNames={["ml-{15}"]} type="l1Bold">
              {game.visitor_score}
            </Label>
          ) : null}
          {/* LOGO */}
          <Div
            classNames={[
              "p-{2}",
              "bgSecondaryMain",
              "borderPrimary",
              "bw-{1}",
              "h-{30}",
              "w-{30}",
              "br-{30}",
              "alignItemsCenter",
              "justifyContentCenter",
              "ml-{10}",
            ]}
          >
            <Label type="l1Regular">M</Label>
          </Div>
          <Label classNames={["ml-{5}", "h5", "mr-{auto}"]}>Markeri</Label>
        </Div>
      </Div>
      {!isFinished(game) ? (
        <Div classNames={["alignItemsCenter", "justifyContentCenter", "mt-{16}"]}>
          <Label type="l2Regular">{moment(game.datetime).format("ddd DD.MM.YYYY HH:mm")}</Label>
          {game.location ? (
            <Label type="l2Regular" classNames={["mt-{4}"]}>
              {game.location}
            </Label>
          ) : null}
          {game.notes ? (
            <Label type="l3Bold" classNames={["mt-{16}"]}>
              {"\n"}
              {game.notes}
            </Label>
          ) : null}
        </Div>
      ) : null}
    </Div>
  );
}
